export function createFileSnapshot(file) {
  return {
    modifiedExifData: { ...file.modifiedExifData },
    hasChanges: file.hasChanges,
  };
}

export function createSnapshotByIndices(files, indices) {
  const snapshotByIndex = {};

  indices.forEach((index) => {
    const file = files[index];
    if (file) {
      snapshotByIndex[index] = createFileSnapshot(file);
    }
  });

  return snapshotByIndex;
}

export function applySnapshotByIndex(files, snapshotByIndex) {
  return files.map((file, index) => {
    const snapshot = snapshotByIndex[index];
    if (!snapshot) return file;

    return {
      ...file,
      modifiedExifData: { ...snapshot.modifiedExifData },
      hasChanges: snapshot.hasChanges,
    };
  });
}

export function patchFileFields(file, fieldValues, options = {}) {
  const nextFile = {
    ...file,
    modifiedExifData: {
      ...file.modifiedExifData,
      ...fieldValues,
    },
  };

  if (typeof options.resolveHasChanges === "function") {
    nextFile.hasChanges = options.resolveHasChanges(nextFile);
  } else if ("hasChanges" in options) {
    nextFile.hasChanges = options.hasChanges;
  }

  return nextFile;
}
